"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _buttons = require("@vds-core/buttons");
var _theme = require("@vds/theme");
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool
};
var defaultProps = {
  inverted: false
};
var _calculateColors = function _calculateColors(surface) {
  return {
    "default": surface === "dark" ? _theme.colors.white : _theme.colors.black,
    hover: surface === "dark" ? _theme.colors.blueInverted : _theme.colors.blue,
    active: _theme.colors.coolGray6,
    disabled: surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3
  };
};
var _calculateUnderLine = function _calculateUnderLine(calculateColors, surface) {
  var color = calculateColors(surface);
  return {
    "default": "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(color["default"]),
    hover: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(color.hover),
    active: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(color.active),
    disabled: "".concat((0, _javascriptStyleHelpers.calculateRem)(1), " solid ").concat(color.disabled)
  };
};
var _calculateLetterSpacing = function _calculateLetterSpacing(size) {
  var letterSpacing = "0px";
  if (size === "large") {
    letterSpacing = "0.5px";
  }
  return letterSpacing;
};
var TextLink = function TextLink(props) {
  return /*#__PURE__*/_react["default"].createElement(_buttons.TextLink, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    calculateColors: _calculateColors,
    calculateUnderLine: _calculateUnderLine,
    calculateLetterSpacing: _calculateLetterSpacing,
    focusRingBorderRadius: "0"
  }));
};
TextLink.propTypes = propTypes;
TextLink.defaultProps = defaultProps;
var _default = exports["default"] = TextLink;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/buttons/dist/cjs/components/TextLink.js
// module id = 1404
// module chunks = 0